import { render } from "./PiarBasicDataTab.vue?vue&type=template&id=7d59a41c&ts=true"
import script from "./PiarBasicDataTab.vue?vue&type=script&lang=ts"
export * from "./PiarBasicDataTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__